function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  gap: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
import React, { useState, useEffect, useRef } from 'react';
import hljs from 'highlight.js';
import styled from '@emotion/styled';
import { useTheme } from '@emotion/react';
import { Clipboard, Check } from 'lucide-react';
// Terminal-specific constants
var COMPACT_THRESHOLD_TERMINAL_PX = 400;
var COMPACT_THRESHOLD_TERMINAL = "".concat(COMPACT_THRESHOLD_TERMINAL_PX, "px");
// --- Terminal Styled Components ---
var TerminalContainer = styled.div(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_radius, _theme_spacing1, _theme_spacing2, _theme_spacing3, _theme_spacing4, _theme_typography_fontSize, _theme_typography, _theme_spacing5, _theme_spacing6, _theme_breakpoints, _theme_typography_fontSize1, _theme_typography1, _theme_spacing7, _theme_spacing8, _theme_spacing9, _theme_spacing10, _theme_spacing11, _theme_spacing12, _theme_typography_fontSize2, _theme_typography2, _theme_spacing13, _theme_spacing14, _theme_spacing15, _theme_spacing16, _theme_spacing17, _theme_spacing18;
    var _obj;
    return _define_property({
        position: 'relative',
        margin: "".concat(((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.md) || '1rem', " 0"),
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.sm) || '0.5rem',
        overflow: 'hidden',
        backgroundColor: '#1e1e1e',
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        'pre': (_obj = {
            position: 'relative',
            margin: '0 !important',
            padding: "".concat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.sm) || '0.5rem', " ").concat(((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.md) || '1rem', " ").concat(((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.sm) || '0.5rem', " calc(").concat(((_theme_spacing4 = theme.spacing) === null || _theme_spacing4 === void 0 ? void 0 : _theme_spacing4.md) || '1rem', " + 1.5ch) !important"),
            borderRadius: '0 !important',
            backgroundColor: "transparent !important",
            color: '#d4d4d4',
            fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.sm) || '0.875rem',
            fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace !important",
            lineHeight: '1.5 !important',
            whiteSpace: 'pre-wrap !important',
            wordBreak: 'break-all',
            '&::before': {
                content: '"$"',
                position: 'absolute',
                left: ((_theme_spacing5 = theme.spacing) === null || _theme_spacing5 === void 0 ? void 0 : _theme_spacing5.md) || '1rem',
                top: ((_theme_spacing6 = theme.spacing) === null || _theme_spacing6 === void 0 ? void 0 : _theme_spacing6.sm) || '0.5rem',
                color: '#888',
                userSelect: 'none',
                fontFamily: 'inherit',
                fontSize: 'inherit'
            }
        }, _define_property(_obj, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
            fontSize: ((_theme_typography1 = theme.typography) === null || _theme_typography1 === void 0 ? void 0 : (_theme_typography_fontSize1 = _theme_typography1.fontSize) === null || _theme_typography_fontSize1 === void 0 ? void 0 : _theme_typography_fontSize1.xs) || '0.75rem',
            padding: "".concat(((_theme_spacing7 = theme.spacing) === null || _theme_spacing7 === void 0 ? void 0 : _theme_spacing7.xs) || '0.25rem', " ").concat(((_theme_spacing8 = theme.spacing) === null || _theme_spacing8 === void 0 ? void 0 : _theme_spacing8.sm) || '0.5rem', " ").concat(((_theme_spacing9 = theme.spacing) === null || _theme_spacing9 === void 0 ? void 0 : _theme_spacing9.xs) || '0.25rem', " calc(").concat(((_theme_spacing10 = theme.spacing) === null || _theme_spacing10 === void 0 ? void 0 : _theme_spacing10.sm) || '0.5rem', " + 1.5ch) !important"),
            '&::before': {
                left: ((_theme_spacing11 = theme.spacing) === null || _theme_spacing11 === void 0 ? void 0 : _theme_spacing11.sm) || '0.5rem',
                top: ((_theme_spacing12 = theme.spacing) === null || _theme_spacing12 === void 0 ? void 0 : _theme_spacing12.xs) || '0.25rem'
            }
        }), _define_property(_obj, "@container (max-width: ".concat(COMPACT_THRESHOLD_TERMINAL, ")"), {
            fontSize: ((_theme_typography2 = theme.typography) === null || _theme_typography2 === void 0 ? void 0 : (_theme_typography_fontSize2 = _theme_typography2.fontSize) === null || _theme_typography_fontSize2 === void 0 ? void 0 : _theme_typography_fontSize2.xs) || '0.75rem',
            padding: "".concat(((_theme_spacing13 = theme.spacing) === null || _theme_spacing13 === void 0 ? void 0 : _theme_spacing13.xs) || '0.25rem', " ").concat(((_theme_spacing14 = theme.spacing) === null || _theme_spacing14 === void 0 ? void 0 : _theme_spacing14.sm) || '0.5rem', " ").concat(((_theme_spacing15 = theme.spacing) === null || _theme_spacing15 === void 0 ? void 0 : _theme_spacing15.xs) || '0.25rem', " calc(").concat(((_theme_spacing16 = theme.spacing) === null || _theme_spacing16 === void 0 ? void 0 : _theme_spacing16.sm) || '0.5rem', " + 1.5ch) !important"),
            '&::before': {
                left: ((_theme_spacing17 = theme.spacing) === null || _theme_spacing17 === void 0 ? void 0 : _theme_spacing17.sm) || '0.5rem',
                top: ((_theme_spacing18 = theme.spacing) === null || _theme_spacing18 === void 0 ? void 0 : _theme_spacing18.xs) || '0.25rem'
            }
        }), _define_property(_obj, 'code', {
            fontFamily: 'inherit !important',
            backgroundColor: 'transparent !important'
        }), _obj)
    }, "@container (max-width: ".concat(COMPACT_THRESHOLD_TERMINAL, ")"), {
        margin: "0",
        borderRadius: '0',
        boxShadow: 'none'
    });
});
var TerminalTopBar = styled.div(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_spacing1, _theme_typography_fontSize, _theme_typography, _theme_breakpoints, _theme_spacing2, _theme_spacing3, _theme_spacing4, _theme_spacing5;
    var _obj;
    return _obj = {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#3c3c3c',
        padding: "".concat(((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.xs) || '0.25rem', " ").concat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.md) || '1rem'),
        color: '#ccc',
        fontSize: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.xs) || '0.75rem',
        borderBottom: "1px solid #555"
    }, _define_property(_obj, "@media (max-width: ".concat(((_theme_breakpoints = theme.breakpoints) === null || _theme_breakpoints === void 0 ? void 0 : _theme_breakpoints.sm) || '640px', ")"), {
        padding: "".concat(((_theme_spacing2 = theme.spacing) === null || _theme_spacing2 === void 0 ? void 0 : _theme_spacing2.xs) || '0.25rem', " ").concat(((_theme_spacing3 = theme.spacing) === null || _theme_spacing3 === void 0 ? void 0 : _theme_spacing3.sm) || '0.5rem')
    }), _define_property(_obj, "@container (max-width: ".concat(COMPACT_THRESHOLD_TERMINAL, ")"), {
        padding: "".concat(parseFloat(((_theme_spacing4 = theme.spacing) === null || _theme_spacing4 === void 0 ? void 0 : _theme_spacing4.xs) || '0.25') * 0.5, "rem ").concat(((_theme_spacing5 = theme.spacing) === null || _theme_spacing5 === void 0 ? void 0 : _theme_spacing5.sm) || '0.5rem')
    }), _obj;
});
var TerminalName = styled.span(function(param) {
    var theme = param.theme;
    var _theme_typography_fontWeight, _theme_typography;
    return {
        fontWeight: ((_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontWeight = _theme_typography.fontWeight) === null || _theme_typography_fontWeight === void 0 ? void 0 : _theme_typography_fontWeight.medium) || 500,
        textTransform: 'uppercase'
    };
});
var ButtonWrapper = styled.div(_templateObject(), function(props) {
    var _props_theme_spacing;
    return ((_props_theme_spacing = props.theme.spacing) === null || _props_theme_spacing === void 0 ? void 0 : _props_theme_spacing.xs) || '0.25rem';
});
var TerminalButton = styled.button(function(param) {
    var theme = param.theme;
    var _theme_spacing, _theme_radius, _theme_spacing1;
    return _define_property({
        padding: "".concat(parseFloat(((_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.xs) || '0.25') * 0.5, "rem"),
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'pointer',
        display: 'inline-flex',
        alignItems: 'center',
        gap: '0.25rem',
        borderRadius: ((_theme_radius = theme.radius) === null || _theme_radius === void 0 ? void 0 : _theme_radius.sm) || '0.25rem',
        transition: "background-color 200ms, color 200ms",
        '&:hover': {
            backgroundColor: '#555',
            color: '#fff'
        },
        svg: {
            width: '14px',
            height: '14px'
        }
    }, "@container (max-width: ".concat(COMPACT_THRESHOLD_TERMINAL, ")"), {
        gap: 0,
        padding: "".concat(parseFloat(((_theme_spacing1 = theme.spacing) === null || _theme_spacing1 === void 0 ? void 0 : _theme_spacing1.xs) || '0.25') * 0.5, "rem"),
        'span': {
            display: 'none'
        }
    });
});
var TerminalCodeBlock = function(param) {
    var code = param.code, propLanguage = param.language, className = param.className, children = param.children;
    var _theme_spacing, _theme_typography_fontSize, _theme_typography;
    var theme = useTheme();
    var terminalContainerRef = useRef(null);
    var codeRef = useRef(null);
    var _useState = _sliced_to_array(useState(false), 2), isCopied = _useState[0], setIsCopied = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), isCompact = _useState1[0], setIsCompact = _useState1[1];
    // Extract language from className or use prop
    var match = /language-(\w+)/.exec(className || '');
    var language = propLanguage || (match === null || match === void 0 ? void 0 : match[1]) || 'shell';
    var displayLanguage = language.toUpperCase();
    // Get code string from props or children
    var codeString = code || React.Children.toArray(children).map(function(child) {
        return typeof child === 'string' ? child : '';
    }).join('').trim();
    // Check compact mode
    useEffect(function() {
        var checkWidth = function() {
            if (terminalContainerRef.current) {
                var width = terminalContainerRef.current.offsetWidth;
                setIsCompact(width < COMPACT_THRESHOLD_TERMINAL_PX);
            }
        };
        checkWidth();
        window.addEventListener('resize', checkWidth);
        return function() {
            return window.removeEventListener('resize', checkWidth);
        };
    }, []);
    useEffect(function() {
        // highlight.js를 사용한 syntax highlighting
        if (codeRef.current && codeString) {
            try {
                hljs.highlightElement(codeRef.current);
            } catch (error) {
                console.warn('Failed to highlight code:', error);
            }
        }
    }, [
        codeString,
        language
    ]);
    // Handlers
    var handleCopy = /*#__PURE__*/ function() {
        var _ref = _async_to_generator(function() {
            var err;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(codeString)
                        ];
                    case 1:
                        _state.sent();
                        setIsCopied(true);
                        setTimeout(function() {
                            return setIsCopied(false);
                        }, 2000);
                        return [
                            3,
                            3
                        ];
                    case 2:
                        err = _state.sent();
                        console.error('Failed to copy code:', err);
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleCopy() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!codeString) return null;
    return /*#__PURE__*/ React.createElement(TerminalContainer, {
        ref: terminalContainerRef
    }, /*#__PURE__*/ React.createElement(TerminalTopBar, null, /*#__PURE__*/ React.createElement(TerminalName, null, displayLanguage), /*#__PURE__*/ React.createElement(ButtonWrapper, null, /*#__PURE__*/ React.createElement(TerminalButton, {
        onClick: handleCopy,
        title: "클립보드에 복사"
    }, isCopied ? /*#__PURE__*/ React.createElement(React.Fragment, null, " ", /*#__PURE__*/ React.createElement(Check, {
        size: 14
    }), " ", !isCompact && /*#__PURE__*/ React.createElement("span", null, "Copied!"), " ") : /*#__PURE__*/ React.createElement(React.Fragment, null, " ", /*#__PURE__*/ React.createElement(Clipboard, {
        size: 14
    }), " ", !isCompact && /*#__PURE__*/ React.createElement("span", null, "Copy"), " ")))), /*#__PURE__*/ React.createElement("pre", {
        style: {
            margin: 0
        }
    }, /*#__PURE__*/ React.createElement("code", {
        ref: codeRef,
        className: "language-".concat(language),
        style: {
            display: 'block',
            padding: (theme === null || theme === void 0 ? void 0 : (_theme_spacing = theme.spacing) === null || _theme_spacing === void 0 ? void 0 : _theme_spacing.md) || '1rem',
            backgroundColor: 'transparent',
            color: '#d4d4d4',
            fontSize: (theme === null || theme === void 0 ? void 0 : (_theme_typography = theme.typography) === null || _theme_typography === void 0 ? void 0 : (_theme_typography_fontSize = _theme_typography.fontSize) === null || _theme_typography_fontSize === void 0 ? void 0 : _theme_typography_fontSize.sm) || '0.875rem',
            fontFamily: "'Consolas', 'Monaco', 'Courier New', monospace",
            lineHeight: '1.5',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-all'
        }
    }, codeString)));
};
export default TerminalCodeBlock;
